import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { breachcrumbPath } from '../utils/breadcrumbConst';
import { useApi } from './useApi';

export type IBulkEmail = {
  title?: string;
  created_by?: string;
  content?: string;
  id?: number;
};

export const useBulkEmail = () => {
  const { id: newsletterId } = useParams();
  const { getOne, getIndex, create, update, upsert, remove } = useApi();

  const baseUrl = 'admin/bulkEmail';
  const name = 'Bulk emails';
  const nameSingle = 'Bulk email';

  const [bulkEmail, setBulkEmail] = useState<IBulkEmail>();
  const [selectedBulkEmails, setSelectedBulkEmails] = useState<number[]>([]);
  const [pageType, setPageType] = useState('add');
  const [selectedValue, setSelectedValue] = useState('');
  const [searchFilter, setSearchFilter] = useState('');
  const [newsletters, setNewsletters] = useState([]);
  const [newsletter, setNewsletter] = useState(null);
  const [emailSettings, setEmailSettings] = useState<any>({});

  const getBreadcrumbs = () => [breachcrumbPath.core, breachcrumbPath.bulkEmail];

  // API Calls
  const getSignedUrl = async (fileName: string, directory: string | undefined = undefined) => {
    const response = await create({ key: fileName, directory }, `${baseUrl}/getSignedUrl`);
    return response;
  };

  const sendTestReminderEmail = async (data: object) => {
    await create(data, `${baseUrl}/reminderEmail`);
  };

  const sendPlatformWideNotification = async (data: object) => {
    await create(data, `${baseUrl}/platformWideNotification`);
  };

  const sendStudyPromotionEmail = async (data: object) => {
    await create(data, `${baseUrl}/studyPromotionEmail`);
  };

  const sendSurveyFeedbackEmail = async (data: object) => {
    await create(data, `${baseUrl}/surveyFeedbackEmail`);
  };

  const updateNewsletterEmail = async (data: object) => {
    const { id } = await update(data, newsletterId!, `${baseUrl}/newsletterEmail`);
    return id;
  };
  const upsertNewsletterEmail = async (data: object) => {
    const { id } = await upsert(data, `${baseUrl}/newsletterEmail`);
    return id;
  };

  const indexNewsletterEmail = async () => {
    const { data } = await getIndex(`${baseUrl}/newsletterEmail`);
    setNewsletters(data);
  };

  const getOneNewsletterEmail = async (id: string) => {
    const { data } = await getOne(id, `${baseUrl}/newsletterEmail`);
    setNewsletter(data);
  };

  const getNewsletterEmail = async () => {
    const { data } = await getIndex(`${baseUrl}/newsletterEmail`);
    setNewsletters(data);
  };

  const removeNewsletterEmail = async (id: string | number) => {
    await remove(`${baseUrl}/newsletterEmail/${id}`);
  };

  const sendNewsletterEmailTest = async (data: object) => {
    await create(data, `${baseUrl}/newsletterEmailTest`);
  };

  const getEmailSettings = async () => {
    const { data } = await getIndex(`${baseUrl}/emailSettings`);
    setEmailSettings(data);
  };

  const updateEmailSettings = async (data: object, id: string | number) => {
    const { image, ...rest }: { image?: File; [key: string]: any } = data;
    if (image) {
      const { signedUrl } = await getSignedUrl(
        'logo-images-from-admin-email-settings/' + image.name
      );
      await fetch(signedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': image.type,
        },
        body: image,
      });

      await update(rest, id, `${baseUrl}/emailSettings`);
    }
  };

  return {
    nameSingle,
    name,
    baseUrl,
    adminUser: bulkEmail,
    selectAdminUsers: selectedBulkEmails,
    pageType,
    setPageType,
    setSelectAdminUsers: setSelectedBulkEmails,
    setAdminUser: setBulkEmail,
    selectedValue,
    setSelectedValue,
    getBreadcrumbs,
    searchFilter,
    setSearchFilter,
    sendTestReminderEmail,
    sendPlatformWideNotification,
    sendStudyPromotionEmail,
    sendSurveyFeedbackEmail,
    updateNewsletterEmail,
    upsertNewsletterEmail,
    newsletter,
    newsletters,
    indexNewsletterEmail,
    getOneNewsletterEmail,
    getNewsletterEmail,
    sendNewsletterEmailTest,
    removeNewsletterEmail,
    emailSettings,
    getEmailSettings,
    updateEmailSettings,
    getSignedUrl,
  };
};
